import styled from 'styled-components'
import { Card, Flex, Typography } from 'antd'
import { mediaMax } from '@/app/styles/breakpoints'
import { IconButton, PrimaryButton } from '../components/Button'

const { Text } = Typography

export const Content = styled.div`
  flex: 1;
  padding: 104px 16px 16px 16px;
  background-color: ${(props) => props.theme.colors.grayBackground};

  display: flex;
  flex-direction: column;
`

export const PageHeader = styled(Flex)`
  text-align: center;
  position: relative;
  padding: 16px 0 32px;
`

export const SectionCard = styled(Card)<{ $isModalView?: boolean }>`
  border-radius: 6px;
  border: none;
  box-shadow: ${(props) =>
    props.$isModalView ? 'none' : '0px 4px 16px 0px #0c10181f'};
  &:not(:last-child) {
    margin-bottom: 32px;
  }

  .ant-card-body {
    padding: 32px 24px;
    display: flex;
    flex-direction: column;
    gap: 32px;
    ${mediaMax.sm} {
      padding: 16px;
      gap: 24px;
    }
  }
`

export const CardHeader = styled(Flex)`
  svg {
    flex: 0 0 auto;
  }
`

export const CardDescription = styled(Text)`
  max-width: 480px;
  color: ${(props) => props.theme.colors.cardDescription};
`

export const TetxLabel = styled(Text)`
  color: ${(props) => props.theme.colors.textLight};
  font-size: ${(props) => props.theme.typography.sizes.xs};
  line-height: ${(props) => props.theme.typography.sizes.lg};
  white-space: nowrap;
`

export const ReloadButton = styled(PrimaryButton)`
  width: 40px;
  ${mediaMax.sm} {
    position: absolute;
    right: 0;
    top: 13px;
  }
`

export const StatsContainer = styled(Flex)`
  background: #f5f5f5;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 16px;
`

export const TasksTabs = styled(Flex)`
  background: ${(props) => props.theme.colors.grayBackground};
  border: 1px solid ${(props) => props.theme.colors.borderInput};
  border-radius: 6px;
`

export const TabButton = styled(IconButton)<{ $active?: boolean }>`
  && {
    padding: 4px 8px;
    background: ${(props) => (props.$active ? 'white' : 'transparent')};
    border: 1px solid
      ${(props) =>
        props.$active ? props.theme.colors.checkbox.border : 'transparent'};
    font-weight: ${(props) => (props.$active ? '600' : '400')};

    &&:hover {
      background: ${(props) => (props.$active ? 'white' : 'transparent')};
      border: 1px solid
        ${(props) =>
          props.$active ? props.theme.colors.checkbox.border : 'transparent'};
      font-weight: ${(props) => (props.$active ? '600' : '400')};
      color: inherit;
    }
  }
`

export const SearchContainer = styled.div`
  flex: 1;
`
